import PropTypes from '~/lib/propTypes'
import { track } from '~/utils/analytics'
import { AUTHENTICATION_VIEWED, SELL_STARTED } from '~/lib/tracking-events'
import { Button } from '@ticketswap/solar'
import AuthDialog from '~/components/AuthDialog'
import { useMutation, useLazyQuery } from '@apollo/client'
import useLoggedInUser from '~/hooks/useLoggedInUser'
import { GET_ACTIVE_DRAFT } from '~/graphql/queries/getActiveDraft'
import { CREATE_DRAFT } from '~/graphql/mutations/createDraft'
import { decodeGlobalId } from '~/utils/id'
import { useRouter } from 'next/router'
import { RouteMap } from '~/lib/routeMap'

const SellTicketsButton = ({
  label,
  eventId,
  eventTypeId,
  size = 'large',
  source = 'menu header',
}) => {
  const router = useRouter()
  const { loggedInUser } = useLoggedInUser()
  const [getActiveDraft, { loading }] = useLazyQuery(GET_ACTIVE_DRAFT)
  const [createDraft] = useMutation(CREATE_DRAFT)

  const startSellingTickets = async () => {
    track(SELL_STARTED, {
      source,
    })

    let draftId
    const {
      data: {
        loggedInUser: { activeDraft },
      },
    } = await getActiveDraft()

    if (!activeDraft) {
      const {
        data: {
          createDraft: { draft },
        },
      } = await createDraft()

      draftId = draft.id
    } else {
      draftId = activeDraft.id
    }

    if (eventId) {
      return router.push({
        pathname: RouteMap['SELL_EVENT'],
        query: {
          eventId,
          eventTypeId,
        },
      })
    }

    router.push({
      pathname: RouteMap['EVENT'],
      query: {
        draftId: decodeGlobalId(draftId),
      },
    })
  }

  return (
    <AuthDialog
      onToggle={on => on && track(AUTHENTICATION_VIEWED, { trigger: 'SELL' })}
      onComplete={startSellingTickets}
    >
      {({ show }) => (
        <Button
          variant="success"
          loading={loading}
          size={size}
          onClick={() => {
            if (loggedInUser) {
              return startSellingTickets()
            }

            return show()
          }}
        >
          {label}
        </Button>
      )}
    </AuthDialog>
  )
}

SellTicketsButton.propTypes = {
  label: PropTypes.string.isRequired,
  eventId: PropTypes.string,
  eventTypeId: PropTypes.string,
  size: PropTypes.string,
}

export default SellTicketsButton
